export default __webpack_public_path__ + "static/media/31_just_a_girl.2409c976.png";